export const RETRIABLE_ERROR_CODES = ['TWEET_NOT_FOUND', 'TWEET_CREATED_BEFORE_QUEST'];
